import React, { useEffect } from "react";
import "../css/botMenu.css";
import { Common } from "./Canvas";
import {
  uploadImage,
  changeToolColor,
  changeGlitterColor,
} from "../js/handlers";
import {
  getColorsOptions,
  getSizesOptions,
  getSizeAndPath,
  getSizesSelected,
} from "../js/toolsOptions";
import { animateSelectedTool } from "../js/handlers";
import Draw from "../js/draw";
//
import eraser from "../images/eraser.png";
import bucket from "../images/bucket.png";
import brush from "../images/brush.png";
import pencil from "../images/pencil.png";
import spray from "../images/sprayCan.png";
import canvas from "../images/canvas.png";
import tape from "../images/tape.png";
import camera from "../images/camera.png";
import photo from "../images/photo.png";
import Utility from "../js/utility";

export default function BotMenu({ setColors, setSizes, handleRightMenu }) {
  // handle bot right menu - image loading;
  useEffect(() => {
    let chooseImage = document.querySelector("#imageChoose");

    function imageClick(ev) {
      ev.target.value = "";
    }
    function inputChange() {
      uploadImage(chooseImage);
    }

    chooseImage.addEventListener("click", imageClick);
    chooseImage.addEventListener("change", inputChange);

    return () => {
      chooseImage.removeEventListener("click", imageClick);
      chooseImage.removeEventListener("change", inputChange);
    };
  });

  // handle bot left menu - size and paths;
  useEffect(() => {
    let menu = document.querySelector(".botMenuLeft");

    function menuClick(ev) {
      if (ev.target.parentNode.nodeName !== "BUTTON") return;

      let tool = ev.target.dataset.tool;
      let colors = getColorsOptions(tool);
      let sizes = getSizesOptions(tool);
      let dimensions = getSizeAndPath(tool);
      let rightMenuContainer = document.querySelector(".rightMenuContainer ");

      setColors(colors);
      setSizes(sizes);

      // if different tool is selected;
      if (tool !== Common.selectedTool) {
        Common.selectedTool = tool;
        Common.tool = tool;
        Common.glitter = false;

        if (sizes) {
          Common.width = dimensions[0];
        }
        if (colors) {
          Common.color = Common.defaultColor;
        }
        if (tool === "eraser") {
          Common.color = Common.bgColor;
          Common.selectedGlitter = null;
        }
        Common.selectedColor = null;

        let buttons = document.querySelectorAll(".toolSizeButton");

        for (let i = 0; i < buttons.length; i++) {
          // reset button background and url;
          if (tool === "eraser") {
            buttons[i].style.background = "url('')";
            buttons[i].style.backgroundColor = Common.erasor_color;
          } else {
            buttons[i].style.background = "url('')";
            buttons[i].style.backgroundColor = Common.defaultColor;
          }

          if (i === 0) {
            buttons[i].firstElementChild.src = getSizesSelected(tool)[0];
            continue;
          }
          buttons[i].firstElementChild.src = sizes[i];
        }
      } else {
        // if same tool is selected;
        if (Common.selectedGlitter) {
          changeGlitterColor();
        } else {
          if (tool === "eraser") {
            let buttons = document.querySelectorAll(".toolSizeButton");
            for (let i = 0; i < buttons.length; i++) {
              // reset button background and url;
              buttons[i].style.background = "url('')";
              buttons[i].style.backgroundColor = Common.erasor_color;
            }
          } else {
            changeToolColor();
          }
        }
      }

      // remove glitter from bucket and spray;
      if (tool === "bucket" || tool === "spray") {
        let pickOptions = document.querySelector(".pickOptions");
        pickOptions.firstElementChild.style.display = "none";
      }

      let toolMenu = document.querySelector(".pickMenuContainer");
      let canvasSpray = document.querySelectorAll("canvas")[1];

      switch (tool) {
        case "pencil":
          toolMenu.className = "pickMenuContainer leftPencil";
          toolMenu.firstElementChild.classList.remove("eraserDarkBorder");
          canvasSpray.style.display = "none";
          break;
        case "brush":
          toolMenu.className = "pickMenuContainer leftBrush";
          toolMenu.firstElementChild.classList.remove("eraserDarkBorder");
          canvasSpray.style.display = "none";
          break;
        case "spray":
          toolMenu.className = "pickMenuContainer leftSpray";
          toolMenu.firstElementChild.classList.remove("eraserDarkBorder");
          canvasSpray.style.display = "block";
          break;
        case "bucket":
          toolMenu.className = "pickMenuContainer leftBucket";
          toolMenu.firstElementChild.classList.remove("eraserDarkBorder");
          canvasSpray.style.display = "none";
          break;
        default:
          toolMenu.className = "pickMenuContainer leftEraser";
          toolMenu.firstElementChild.classList.add("eraserDarkBorder");
          canvasSpray.style.display = "none";
      }

      toolMenu.classList.add("showPickMenu");
      rightMenuContainer.classList.remove("showPatternMenu");
    }

    menu.addEventListener("click", menuClick);

    return () => {
      menu.removeEventListener("click", menuClick);
    };
  });

  // handle bot right menu;
  useEffect(() => {
    let canvasButton = document.querySelector(".canvasButton");
    let tapeButton = document.querySelector(".tapeButton");
    let rightMenuContainer = document.querySelector(
      !Common.mobile ? ".rightMenuContainer" : ".rightMenuContainerDevice"
    );
    let rightMenuBorder = document.querySelector(
      !Common.mobile ? ".rightMenuBorder" : ".rightMenuBorderDevice"
    );

    function handleCanvasButton() {
      canvasButton.classList.add("selected_pattern_button");
      rightMenuContainer.classList.add("showPatternMenu");
      rightMenuContainer.classList.remove("tapeArrow");
      !Common.mobile
        ? rightMenuContainer.classList.remove("tapeArrow")
        : rightMenuContainer.classList.remove("tapeArrowDevice");
      rightMenuBorder.classList.remove("tapeArrowLightBlue");
      !Common.mobile
        ? rightMenuBorder.classList.remove("tapeArrowLightBlue")
        : rightMenuBorder.classList.remove("tapeArrowLightBlueDevice");

      Common.previous_selected_tool_id = Common.selected_tool_id;

      handleRightMenu("canvases");
    }

    function handleTapesButton() {
      tapeButton.classList.add("selected_pattern_button");
      rightMenuContainer.classList.add("showPatternMenu");
      rightMenuContainer.classList.add("tapeArrow");
      !Common.mobile
        ? rightMenuContainer.classList.add("tapeArrow")
        : rightMenuContainer.classList.add("tapeArrowDevice");
      rightMenuBorder.classList.add("tapeArrowLightBlue");
      !Common.mobile
        ? rightMenuBorder.classList.add("tapeArrowLightBlue")
        : rightMenuBorder.classList.add("tapeArrowLightBlueDevice");

      handleRightMenu("tapes");
    }

    function outsideRightMenu(ev) {
      let element = ev.target;
      let closePattern = rightMenuContainer.querySelector(".canvasesClose");

      if (
        rightMenuContainer.contains(element) &&
        !closePattern.contains(element)
      ) {
      } else {
        // click outside menu and outside canvas button;
        if (
          !rightMenuContainer.contains(element) &&
          !canvasButton.contains(element)
        ) {
          // click outside tape button;
          if (!tapeButton.contains(element)) {
            rightMenuContainer.classList.remove("showPatternMenu");
          }

          canvasButton.classList.remove("selected_pattern_button");
        }

        // click outside tape button;
        if (!tapeButton.contains(element)) {
          // click outside canvas button;
          if (!canvasButton.contains(element)) {
            rightMenuContainer.classList.remove("showPatternMenu");
          }
        }

        if (closePattern.contains(element)) {
          rightMenuContainer.classList.remove("showPatternMenu");
          canvasButton.classList.remove("selected_pattern_button");
        }
      }
    }

    document.addEventListener("click", outsideRightMenu);
    canvasButton.addEventListener("click", handleCanvasButton);
    tapeButton.addEventListener("click", handleTapesButton);

    return () => {
      document.removeEventListener("click", outsideRightMenu);
      canvasButton.removeEventListener("click", handleCanvasButton);
      tapeButton.removeEventListener("click", handleTapesButton);
    };
  });

  // tape menu listeners
  useEffect(() => {
    let tape_menu = document.querySelector("[data-name='tapes']");

    // if inside tape menu, change pattern when with clicked one;
    if (tape_menu) {
      tape_menu.addEventListener("click", selectTape);

      function selectTape(ev) {
        let element = ev.target;

        if (element.nodeName !== "IMG") return;
        Common.tape_pattern = element.src;
      }

      return () => {
        tape_menu.removeEventListener("click", selectTape);
      };
    }
  });

  const setPosition = (ev) => {
    let rect = ev.target.getBoundingClientRect();
    let points = { x: 0, y: 0 };
    let x = Common.mobile ? ev.touches[0].clientX : ev.clientX;
    let y = Common.mobile ? ev.touches[0].clientY : ev.clientY;

    points.x = x - rect.left;
    points.y = y - rect.top;

    return points;
  };

  // draw tape;
  useEffect(() => {
    let tape_wrapper = document.querySelector(".tape_wrapper");
    let tape_canvas = document.querySelector(".tape_canvas");
    let ctx_tape = tape_canvas.getContext("2d");

    tape_canvas.setAttribute("class", "tape_canvas");

    tape_wrapper.addEventListener(Common.pointerdown, pointerdown);

    function pointerdown(ev) {
      Utility.hideMenus();

      let main_canvas_rect = Common.main_canvas.getBoundingClientRect();
      let main_canvas_left = main_canvas_rect.left;
      let main_canvas_top = main_canvas_rect.top;

      let initial_pos = setPosition(ev);
      let patternImage = new Image();
      let pattern;

      let pattern_height = 61;
      let pattern_width = 204;

      patternImage.crossOrigin = "anonymous";

      if (Common.font_size) {
        pattern_height = Common.font_size * 0.091;
        pattern_width = Common.font_size * 0.3045;
      }

      // using a temporary canvas to allow resizing on pattern image;
      let temp_canvas = document.createElement("canvas");
      let temp_ctx = temp_canvas.getContext("2d");

      tape_canvas.height = pattern_height;
      patternImage.src = Common.tape_pattern;

      temp_canvas.width = pattern_width;
      temp_canvas.height = pattern_height;
      temp_ctx.drawImage(patternImage, 0, 0, pattern_width, pattern_height);

      tape_canvas.style.left = initial_pos.x + "px";
      pattern = ctx_tape.createPattern(temp_canvas, "repeat-x");

      document.addEventListener(Common.pointermove, mousemove);
      document.addEventListener(Common.pointerup, mouseup);

      let angle_degree;

      function mousemove(ev) {
        ev.preventDefault();
        ctx_tape.fillStyle = pattern;

        let ev_X = Common.mobile ? ev.touches[0].clientX : ev.clientX;
        let ev_Y = Common.mobile ? ev.touches[0].clientY : ev.clientY;
        let page_X = Common.mobile ? ev.touches[0].pageX : ev.pageX;
        let page_Y = Common.mobile ? ev.touches[0].pageY : ev.pageY;

        // ----------------------
        // calculate canvas's width from distance between x/y click coordinates and x/y movement coordinates;
        let x = Math.round(initial_pos.x) - ev_X;
        let y = Math.round(initial_pos.y) - ev_Y;

        let distance = Math.hypot(x, y);

        tape_canvas.width = distance * 2;

        // ----------------------
        // set canvas's center, x/y, to be where click occurred;
        let tape_canvas_width = tape_canvas.width;
        let tape_canvas_height = tape_canvas.height;
        let left = initial_pos.x - tape_canvas_width / 2 - main_canvas_left;
        let top = initial_pos.y - tape_canvas_height / 2 - main_canvas_top;

        tape_canvas.style.left = left + "px";
        tape_canvas.style.top = top + "px";

        // ----------------------
        // rotate canvas to face mouse pointer;
        let centerX = left + tape_canvas.clientWidth / 2;
        let centerY = top + tape_canvas.clientHeight / 2;
        let mouseX = page_X;
        let mouseY = page_Y;
        let radians = Math.atan2(mouseX - centerX, mouseY - centerY);
        let degree = radians * (180 / Math.PI) * -1 + 90;

        angle_degree = degree;

        tape_canvas.style.transform = `rotate(${degree}deg)`;

        // ----------------------
        // canvas drawing stuff;
        ctx_tape.save();

        // pattern offset
        ctx_tape.translate(
          tape_canvas_width / 2,
          tape_canvas_height / 2 - pattern_height / 2
        ); // <---------------------------------------------------------

        ctx_tape.rect(0, 0, tape_canvas_width, tape_canvas_height);
        ctx_tape.fillStyle = pattern;
        ctx_tape.fill();

        // undo pattern offset
        ctx_tape.restore();
      }

      function mouseup() {
        Utility.revealMenus();

        let main_ctx = Common.main_ctx;
        let history_ctx = Common.history_ctx;
        let tape_canvas_left = tape_canvas.offsetLeft + tape_canvas.width / 2;
        let tape_canvas_top = tape_canvas.offsetTop + tape_canvas.height / 2;

        main_ctx.save();
        main_ctx.translate(tape_canvas_left, tape_canvas_top);
        main_ctx.rotate((Math.PI / 180) * angle_degree);
        main_ctx.translate(-tape_canvas.width / 2, -tape_canvas.height / 2);
        history_ctx.save();
        history_ctx.translate(tape_canvas_left, tape_canvas_top);
        history_ctx.rotate((Math.PI / 180) * angle_degree);
        history_ctx.translate(-tape_canvas.width / 2, -tape_canvas.height / 2);

        main_ctx.drawImage(tape_canvas, 0, 0);
        main_ctx.restore();
        history_ctx.drawImage(tape_canvas, 0, 0);
        history_ctx.restore();

        tape_canvas.width = 1;
        ctx_tape.clearRect(0, 0, tape_canvas.width, tape_canvas.height);
        history_ctx.clearRect(0, 0, tape_canvas.width, tape_canvas.height);

        Draw.history.addToHistoryTest();

        document.removeEventListener(Common.pointermove, mousemove);
        document.removeEventListener(Common.pointerup, mouseup);
      }
    }

    let image = new Image();
    image.crossOrigin = "anonymous";
    image.src = Common.tape_pattern;
    image.crossOrigin = "anonymous";

    return () => {
      tape_wrapper.removeEventListener(Common.pointerdown, pointerdown);
    };
  });

  useEffect(() => {
    let botMenuContainers = document.querySelector(".botMenuContainers");

    botMenuContainers.addEventListener("click", menuButtonClick);
    document.addEventListener("click", backgroundTool);
    document.addEventListener("click", cameraTool);

    function setPrevious() {
      if (Common.selected_tool_id === "6" || Common.selected_tool_id === "8") {
        return;
      }

      Common.previous_selected_tool_id = Common.selected_tool_id;
    }
    function menuButtonClick(ev) {
      let element = ev.target.parentNode;

      if (element.nodeName !== "BUTTON" || !element.dataset.toolid) return;

      // remember previous in case of camera, backgrounds;
      if (
        (element.dataset.toolid === "6" || element.dataset.toolid === "8") &&
        Common.previous_selected_tool_id !== "6" &&
        Common.previous_selected_tool_id !== "8"
      ) {
        setPrevious();
      }

      if (element.dataset.toolid === "8") return;

      Common.selected_tool_id = element.dataset.toolid;

      animateSelectedTool();
    }

    // close canvas tool and re-animate the previous one after done, so the tool won't stay open;
    function backgroundTool(ev) {
      if (Common.selected_tool_id !== "6") return;

      let canvas_menu = document.querySelector("[data-name='canvases']");
      let canvas_button = document.querySelector(".canvasButton ");
      let element = ev.target;

      if (!canvas_menu.contains(element) && !canvas_button.contains(element)) {
        Common.selected_tool_id = Common.previous_selected_tool_id;
        animateSelectedTool();
      }
    }
    function cameraTool(ev) {
      if (Common.selected_tool_id !== 8) return;

      let camera_button = document.querySelector("#camera");
      let element = ev.target;

      if (!camera_button.contains(element)) {
        Common.selected_tool_id = Common.previous_selected_tool_id;
        animateSelectedTool();
      }
    }

    return () => {
      botMenuContainers.removeEventListener("click", menuButtonClick);
      document.removeEventListener("click", backgroundTool);
      document.removeEventListener("click", cameraTool);
    };
  });

  return (
    <div className="botMenuContainers">
      <div className="botMenuLeft">
        <button className="bot_tool" data-toolid="1">
          <img src={eraser} alt="" data-tool="eraser" />
        </button>
        <button className="bot_tool" data-toolid="2">
          <img src={pencil} alt="" data-tool="pencil" />
        </button>
        <button className="bot_tool" data-toolid="3">
          <img src={brush} alt="" data-tool="brush" />
        </button>
        <button className="bot_tool" data-toolid="4">
          <img src={spray} alt="" data-tool="spray" />
        </button>
        <button className="bucketButton bot_tool" data-toolid="5">
          <img src={bucket} alt="" data-tool="bucket" />
        </button>
      </div>
      <div className="botMenuRight">
        <button className="canvasButton bot_tool" data-toolid="6">
          <img src={canvas} alt="" data-tool="canvas" />
        </button>
        <button className="tapeButton bot_tool" data-toolid="7">
          <img src={tape} alt="" data-tool="tape" />
        </button>
        {!Common.mobile ? (
          <button id="camera" className="bot_tool" data-toolid="8">
            <img src={camera} alt="" data-tool="camera" />
          </button>
        ) : (
          ""
        )}
        <button>
          <label htmlFor="imageChoose" className="addPhotoButton">
            <input id="imageChoose" type="file" accept="image/png,image/jpeg" />

            <img
              src={Common.mobile ? camera : photo}
              alt=""
              data-tool="gallery"
            />
          </label>
        </button>
      </div>
    </div>
  );
}
